// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://web-production-dfa6.up.railway.app';

export const API_ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  PROJECTS: (userId) => `${API_BASE_URL}/projects/${userId}`, // GET projects for a user
  PROJECTS_CREATE: `${API_BASE_URL}/projects`, // POST to create a new project
  PROJECT_CONFIG: (projectId) => `${API_BASE_URL}/projects/${projectId}/config`,
  PROJECT_CONFIG_APIKEY: (projectId) => `${API_BASE_URL}/projects/${projectId}/config/apikey`,
  PROJECT_CONFIG_PROMPT: (projectId) => `${API_BASE_URL}/projects/${projectId}/config/prompt`,
  PROJECT_CONFIG_DOMAINS: (projectId) => `${API_BASE_URL}/projects/${projectId}/config/domains`,
  API_KEYS: (userId) => `${API_BASE_URL}/api-keys/${userId}`,
  FILES: (projectId) => `${API_BASE_URL}/files/${projectId}`,
  FILE_DELETE: (projectId, fileId) => `${API_BASE_URL}/files/${projectId}/${fileId}`,
  EMBED: (projectId) => `${API_BASE_URL}/embed/${projectId}`,
  WIDGET_SCRIPT: `${API_BASE_URL}/widget.js`,
  CHAT: `${API_BASE_URL}/chat`
};

// Optimized API configuration
export const apiConfig = {
  timeout: 15000, // 15 second timeout
  retries: 2,
  retryDelay: 1000
};

// Optimized chat API call with retry logic and timeout
export const sendChatMessage = async (message, projectId, apiKey) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), apiConfig.timeout);

  try {
    const response = await fetch(API_ENDPOINTS.CHAT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify({ 
        message: message.trim(), 
        projectId 
      }),
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    clearTimeout(timeoutId);
    
    if (error.name === 'AbortError') {
      throw new Error('Request timed out. Please try again.');
    }
    throw error;
  }
};

// Generic optimized API call function
export const apiCall = async (url, options = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), apiConfig.timeout);

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
    signal: controller.signal
  };

  try {
    const response = await fetch(url, { ...defaultOptions, ...options });
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    clearTimeout(timeoutId);
    
    if (error.name === 'AbortError') {
      throw new Error('Request timed out. Please try again.');
    }
    throw error;
  }
};

export default API_ENDPOINTS;
